module.exports = __webpack_public_path__ + "static/media/Outlook_Video.9431664b.mp4";